export default [
  {
    path: '/apps/comunicado/list',
    name: 'apps-comunicado-list',
    component: () => import('@/views/cadastros/comunicado/comunicado/list/Index.vue'),
    meta: {
      pageTitle: 'Comunicado',
    },
  },
];
